module.exports = __webpack_public_path__ + "img/SSLRECN.dece2546.svg";